import { useTranslation } from 'react-i18next'

import type { ListingRemakeSlot } from '@/lib/api/listing-builder.types'
import { RemakeSlotCard } from './RemakeSlotCard'

interface RemakeImageSlotsProps {
  slots: ListingRemakeSlot[]
}

/** Read-only grid of remake image slots. */
export function RemakeImageSlots({ slots }: RemakeImageSlotsProps) {
  const { t } = useTranslation()

  if (!slots || slots.length === 0) {
    return (
      <p className="listing-builder-remake-slots-empty text-sm text-neutral-400">
        {t('listingBuilder.remake.noImages')}
      </p>
    )
  }

  return (
    <div className="listing-builder-remake-slots grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {slots.map((slot) => (
        <RemakeSlotCard key={slot.id} slot={slot} />
      ))}
    </div>
  )
}
